import { Boxed } from 'ngrx-forms';

import { FilterValue } from '@heitown/common-interfaces';

export interface FilterFormValueInterface {
  filters: Boxed<FilterValue[]>;
}
